export default __webpack_public_path__ + "static/bosch-44fb34ba013f8c56762d4a0b78eca457.png";